module.exports = __webpack_public_path__ + "img/455-3cf689.png";